module.exports = __webpack_public_path__ + "img/toulouse-logo-icon.9a0aec3f.png";